import { Reveal, Label } from "./primitives";

const VOICES = [
  {
    quote:
      "I was honestly a little sceptical before the session, but kuch insights literally hit home. Mujhe realise hua ki main baar-baar same pattern repeat kar rahi thi. I came out of the session feeling much more aware and peaceful.",
    name: "Simran Arora",
    location: "Melbourne, Australia",
    tag: "Tarot Reading",
  },
  {
    quote:
      "The energy protection session was a beautiful experience. What I appreciated most was that Ishita didn't make me feel dependent on her. She taught me simple ways to become more aware of my own energy and boundaries.",
    name: "Aditi Malhotra",
    location: "London, UK",
    tag: "Energy Protection",
  },
  {
    quote:
      "Aura cleansing ke baad I felt so much lighter. I had been feeling emotionally drained for quite some time. The session gave me a beautiful space to pause, release and just breathe.",
    name: "Neha Bansal",
    location: "Noida, India",
    tag: "Aura Cleansing",
  },
];

export const Testimonials = () => (
  <section
    id="voices"
    data-testid="testimonials-section"
    className="relative py-24 md:py-32 px-6 md:px-10 bg-[#130C1E]"
  >
    <div className="max-w-[1400px] mx-auto">
      <Reveal>
        <Label>Voices</Label>
        <h2 className="mt-5 font-serif-display font-light text-4xl sm:text-6xl text-[#EAE0D5] tracking-tight leading-none max-w-2xl">
          Words from those who <span className="italic text-[#D4AF37]">felt the shift</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {VOICES.map((v, i) => (
          <Reveal key={v.name} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full rounded-2xl border border-[#2A1F3D] bg-[#07040D] p-8 flex flex-col justify-between"
            >
              <span className="font-serif-display text-5xl text-[#D4AF37]/40 leading-none">
                &ldquo;
              </span>
              <blockquote className="mt-2 font-serif-display text-xl text-[#EAE0D5] font-light leading-relaxed italic">
                {v.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#2A1F3D]">
                <div className="text-[#EAE0D5] text-sm">{v.name}</div>
                <div className="text-xs text-[#756D7A] mt-0.5">
                  {v.location}
                </div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#D4AF37] mt-1">
                  {v.tag}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
